/**
 *  Module for the nav flyout menu
 */

const Menu = function (app) {
  /**
   *  Private Properties/Methods
   */
  const configure = app.configure,
    $ = require('jquery'),
    _ = require('lodash'),
    $container = app.$container;

  const inputText = require('./input_text')(app);
  const navigationArrows = require('./navigation_arrows')(app);
  let MenuComponent;

  const component = () => { return MenuComponent; };


  /* ====================================
  =            Placeholders             =
  ==================================== */
  const getSubAttributeArtwork = (attributes) => attributes.filter(attr => attr.alias === app.appUtils.hasUiAlias('artwork_color_index'));

  const setPlaceHolderValue = (targetClass, data) => {
    const caAlias = '.fc-attribute-selector-alias-';
    _.defer(() => {
      $container.find(`${caAlias}${targetClass} input`).attr('placeholder', data);
    });
  };

  const applyMetadataToPlaceholders = (selectedValue = {}) => {
    if (selectedValue.metadata) {
      const target = 'target_ca_';
      const metadata = app.utils.getMetaData(selectedValue);
      // This is a check to see if an alias with the _ui convention then we need
      // to alter the targetClass with _ui as well so the correct input is updated
      const hasUiAlias = app.helpers.hasAttribute('artwork_color_index_ui');
      const regEx = (app.appUtils.isPrintAndEmbroideryProduct()) ?
        new RegExp(/default_text_pe_(\d?)/) :
        new RegExp(/default_text_(\d?)/);

      _.map(metadata, (data, key) => {
        if (regEx.test(key)) {
          const index = key.match(regEx)[1];
          // This will construct the class name of the input field
          // (e.g. type_1_text, type_1_text_ui)
          const targetClass = metadata[target + index] +
            (hasUiAlias ? '_ui' : '');

          setPlaceHolderValue(targetClass, data);
        }
      });
    }
  };

  const updatePlaceholders = (selectedValue, attribute) => {
    applyMetadataToPlaceholders(selectedValue);
    if (attribute.subAttributes) {
      const artworkAttribute = getSubAttributeArtwork(attribute.subAttributes)[0];
      if (artworkAttribute) {
        const selectedArtworkValue = artworkAttribute.values.filter(value => value.selected)[0];
        applyMetadataToPlaceholders(selectedArtworkValue);
      }
    }
  };

  /* =====  End of Placeholders  ====== */

  /* ======================================
  =            Size selection             =
  ====================================== */
  const LOADING_CLASS = 'fc-selector-loading';
  function toogleSizeSelectionsVisibility() {
    $('.fc-attribute-selector-alias-size').find('.fc-attribute-selector-button').toggleClass(LOADING_CLASS);
  }

  function updateSelectedSize(selectedSize) {
    return app.actions.updateSize(selectedSize);
  }

  function selectSize() {
    const currentSize = app.store.currentSize();
    // const attributes = app.getRenderableAttributes();
    if (currentSize) {
      const sizes = configure.run('getAttribute', { alias: 'size' }).values.filter(function (value) {
        return value.selectable;
      });
      const sizeNames = sizes.map(function (size) {
        return size.name;
      });
      const matchSizePosition = sizeNames.indexOf(currentSize.name);
      if (matchSizePosition !== -1) {
        const sameSizeName = sizes[matchSizePosition];
        configure.run('setRecipe', [{ ca: { alias: 'size' }, av: sameSizeName }], app._callback);
      } else {
        console.log('Selected size not available in the current model. Size not found: ', currentSize.name);
        const newSizeSelected = sizes.filter(function (size) {
          return size.selected;
        })[0];
        updateSelectedSize(newSizeSelected);
      }
    } else {
      updateSelectedSize();
    }
    setTimeout(function () {
      toogleSizeSelectionsVisibility();
    }, 200);
  }
  function updateSize(attribute, selectedValue) {
    if (attribute.alias === 'size') {
      updateSelectedSize(selectedValue);
    } else {
      toogleSizeSelectionsVisibility();
      _.defer(selectSize);
    }
  }

  /* =====  End of Size selection  ====== */


  function updatePageNumber() {
    _.defer(function () {
      const pageNumber = $container.find('.fc-pager-page-number').text();
      const page = pageNumber.match(/(\d)\/(\d)/);
      $container.find('.fc-pager-page-group-name').text(page[1] + ': ');
    });
  }

  function isVisible(el) {
    return el && el.offsetParent !== null &&
      !el.querySelector('.fc-attribute-value-swatch').classList.contains('fc-av-unselectable');
  }

  function getFirstVisibleValue(values) {
    return _.head(_.compact(Array.from(values).map(value =>
      isVisible(value) ?
        _.parseInt(value.querySelector('.fc-attribute-value-swatch').getAttribute('data-value')) :
        null
    )));
  }

  function getColorAttribute() {
    const alias = app.appUtils.hasAttribute('color') ?
      'color' : 'select_color';

    return {
      alias,
      color: app.configure.run('getAttribute', { alias })
    };
  }

  function updateColorUi(state, colorSwatchContainer) {
    const elems = colorSwatchContainer.querySelectorAll('.fc-ca-legend, .fc-attribute-title');
    _.forEach(elems, (elem) => elem.classList[state ? 'add' : 'remove']('fc-hidden'));
  }

  // Remove all Color AV DOM elements that do not have sizes to select
  function removeColorsWithNoSize() {
    // If the bypassColorRemoval param is set then stop immediately
    if (app.mergedParams.bypassColorRemoval) { return; }
    // Get the color values that are currently selectable
    const { color, alias } = getColorAttribute();
    const colorValues = _.filter(color.values, { selectable: true });
    const error_message = document.querySelector('.fc-no-available-colors-message');

    if (error_message) {
      document.querySelector('.fc-no-available-colors-message').remove();
    }

    // Loop over each one
    _.forEach(colorValues, (value) => {
      // Preview each color value and see if the Size CA is returned
      // in the JSON data.
      app.configure.run('previewValue', {
        ca: {
          alias
        }, av: {
          id: value.id
        }
      }, 'human', (err, data) => {
        if (err) { throw err; }

        // If no size is returned then remove the AV from ther DOM and
        // log an analytics event
        if (!data.size) {
          const element = document.querySelector(`.fc-swatch-ca-${alias}-av-${value.id}`);

          if (element) {
            element.style.display = 'none';
            app.analytics.track('color-has-no-size', {
              ca: { id: color.id },
              av: { id: value.id, vendorId: value.vendorId }
            });
          }
        }
      });
    });

    // After the colors have been processed validate that there are
    // active colors to choose.
    const colorSwatchContainer = document.querySelector(`.fc-attribute-selector-alias-${alias}`);

    if (colorSwatchContainer) {
      updateColorUi(false, colorSwatchContainer);

      const colorSwatches = colorSwatchContainer.querySelectorAll('.fc-swatch-ca');
      const colorSwatchArr = Array.from(colorSwatches);

      // If no colors are available then we need to ensure we display a
      // message to the user and disable the cart button.
      if (!colorSwatchArr.some(x => isVisible(x))) {
        // Disable the cart button
        app.mergedParams.noColorsAvailable = true;
        app.cart.updateAddToCart();

        updateColorUi(true, colorSwatchContainer);
        colorSwatchContainer.querySelector('.fc-attribute-selector-custom-before-html-hook').innerHTML = `<p class="fc-no-available-colors-message">${app.l10n.getLang('no_swatch_available', 'All values are currently unavailable at this time.')}</p>`;

        app.analytics.track('product-has-no-colors');
      } else {
        // Check to see if the first color was removed. If so ensure the
        // first available AV is chosen
        const currColor = app.helpers.getSelectedValueByAlias(alias);
        const currSelected = colorSwatchContainer.querySelector(`.fc-swatch-ca-${alias}-av-${currColor.id}`);

        if (!isVisible(currSelected)) {
          const id = getFirstVisibleValue(colorSwatches);

          configure.run('selectValue', {
            ca: alias,
            av: { id }
          });
        }
      }
    }

    app.horizontalPagination.horizontalPages();
  }


  /**
   *
   * This is the initial function that loads the menu (accordion or pager)
   * Initialise all the customizations.
   *
   */
  function init() {
    app.registerHook.skuElementCreated = false;
    app.registerHook.styleNumberElementCreated = false;
    const options = {
      type: 'accordion',
      container: '.fc-menu-container'
    };
    configure.run('setComponentOptions', {
      'attributeSelector': {
        uiSettings: {
          placeholder: app.l10n.getLang('default_input_placeholder_text', 'ABC')
        }
      }
    });
    if (app.utils.isMobile() || app.utils.isVerticalTablet()) {
      options.type = 'pager';
      options.showElements = [
        'attributesPulldown', 'header', 'previousAttribute', 'nextAttribute'
      ];
    }
    configure.run('createComponent', options, function (err, menu) {
      app._callback(err);

      const attr = app.getRenderableAttributes()[0],
        selected = app.helpers.getSelectedValueByAlias(attr.alias);
      // when configure loads, we update the link at the initial panel.
      app.registerHook.updateGlobalLinks(selected, attr);
      const selectedSize = attr.subAttributes.filter(function (subAttribute) {
        if (subAttribute.alias === 'size') {
          return true;
        } else {
          return false;
        }
      })[0].values.filter(function (value) {
        return value.selected;
      })[0];
      updateSelectedSize(selectedSize);
      app.registerHook.updateStyleNumberElement();
      app.registerHook.updateSkuElement();
      if (app.appUtils.isDTGProduct()) {
        menu.on('input:change', inputText.updateStoredText);
      }
      menu.on('attributeList:setIndex', function (index) {
        // With the page component the index value is either "next" or "prev"
        // Update a static index value in this instance
        if (!app.menu.currentIndex) {
          app.menu.currentIndex = 0;
        }
        if (index === 'next') {
          app.menu.currentIndex++;
        }
        if (index === 'prev') {
          app.menu.currentIndex--;
        }
        if (_.isString(index)) {
          index = app.menu.currentIndex;
        } else if (_.isNumber(index)) {
          app.menu.currentIndex = index;
        }
        const renderableAttributes = app.getRenderableAttributes(),
          attr = renderableAttributes[index],
          selected = app.helpers.getSelectedValueByAlias(attr.alias);
        if (options.type === 'pager') {
          navigationArrows.setNavigationArrowsStatus(renderableAttributes.length);
        }
        if (app.appUtils.isDTGProduct()) {
          inputText.updateMaxLength();
        }

        updatePlaceholders(selected, attr);
        app.registerHook.updateGlobalLinks(selected, attr);
        app.analytics.track('attribute-opened', {
          name: attr.alias,
          attr,
          selected
        });
      });

      menu.on('av:change', function (change) {
        const attribute = configure.run('getAttribute', { 'id': change.caId });
        const selectedValue = _.find(attribute.values, { 'id': change.avId });

        updatePlaceholders(selectedValue, attribute);
        app.updateRecipeOms.omsMenuNormalizing(selectedValue, attribute);

        app.registerHook.updateGlobalLinks(selectedValue, attribute);
        updateSize(attribute, selectedValue);
        if (options.type === 'accordion') {
          app.horizontalPagination.horizontalPages();
        }

        _.delay(() => {
          // Handle ADA compliance for hidden size AV's
          const hidden = $container.find('.fc-av-unselectable');

          _.forEach(hidden, (av) => {
            $(av)
              .attr('aria-disabled', true)
              .find('.fc-button-pair').attr('tabIndex', null);
          });
        });
      });

      removeColorsWithNoSize();

      if (options.type !== 'pager') {
        app.horizontalPagination.setSwatchRows();
        app.horizontalPagination.horizontalPages();
        menu.on('attributeList:setIndex', app.horizontalPagination.horizontalPages);
        configure.on('facet:change', () => {
          _.defer(removeColorsWithNoSize);
        });
      } else {
        menu.on('display:viewChange', function () {
          updatePageNumber();
        });
        updatePageNumber();
        navigationArrows.addBottomNavigationArrows(menu);
      }

      MenuComponent = menu;
    });
  }
  /**
   *  Expose Public Properties/Methods
   */
  return {
    init,
    component,
    navigationArrows,
    updateMaxLength: inputText.updateMaxLength
  };
};

module.exports = Menu;
